<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>直近性考慮: {{ _recency }}</div>
    <div>固定商品: {{ fixedItems.length }}商品</div>
    <div>前回提案ファイル: {{ previousRecommendFilename }}</div>
    <div>提案順: {{ _recommendOrder }}</div>
    <div>ダブリ回避: {{ categoryRedundant ? 'あり' : 'なし' }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    recency: String,
    fixedItems: Array,
    previousRecommendFilename: String,
    recommendOrder: Array,
    categoryRedundant: Number,
    errors: {
      type: Array,
    },
  },
  computed: {
    _recency() {
      switch (this.recency) {
        case 'purchase':
          return '顧客販売'
        case 'store':
          return '利用店舗販売'
        default:
          return '考慮なし'
      }
    },
    _recommendOrder() {
      return this.recommendOrder.map(r => r.label).join(', ')
    },
  },
}
</script>
